import { GraphQLObjectType, GraphQLString } from 'graphql';

import { TypeNames } from '../../types';

const TeamLinkIcon = new GraphQLObjectType({
	fields: {
		linkUrl: {
			type: GraphQLString,
		},
		iconUrl: {
			type: GraphQLString,
		},
		productName: {
			type: GraphQLString,
		},
	},
	name: TypeNames.TEAM_LINK_ICON,
	description: 'Icon URL to use for a link',
});

export default TeamLinkIcon;
